<template>
  <div>
    <Form style="margin: 30px 20px" :model="formItem" :label-width="120" label-position="left">
      <Row>
        <Col span="6">
          <FormItem label="应聘职位:">
            <Input v-model="formItem.candidatePosition" :disabled="loading"/>
          </FormItem>
        </Col>
        <Col span="6" offset="1">
          <FormItem label="申请单状态：">
            <Select v-model="formItem.beInitiateApplication" :disabled="loading" :clearable="true" placeholder="">
              <Option
                :value="item.code"
                v-for="(item, i) in SQDZTList"
                :key="i"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="4" offset="1">
          <Button type="primary" @click="initgetData" :disabled="loading"><!-- 检索 -->{{$t('Search')}}</Button>
        </Col>
      </Row>
    </Form>
    <Card style="margin-top: 20px">
      <Table border ref="selection" :loading="loading" :columns="preOnboardingColumns" :data="preOnboardingData"
        width="100%" stripe>
        <template slot-scope="{ row, index }" slot="action">
          <Icon type="md-eye" color="#8CD29B" style="font-size: 26px;" @click="preOnboardinglOpen(row,index)"/>
        </template>
        <template slot-scope="{ row, index }" slot="action1">
          <Button @click="initiateInduction(row,index)" type="primary">发起入职</Button>
          <!-- <Icon type="md-eye" color="#8CD29B" style="font-size: 26px;" @click="preOnboardinglOpen(row,index)"/> -->
        </template>
        <Button type="primary">发起入职</Button>
      </Table>
      <Row style="margin-top:15px;float:right">
        <Col span="24">
          <Page :total="total" :page-size="pageInfo.pageSize" @on-change="pageChange" />
        </Col>
      </Row>
      <!-- <Row style="margin-top:15px">
        <Col span="19">
          <Button type="primary">发起入职</Button>
        </Col>
      </Row> -->
    </Card>
  </div>
</template>

<script>
  import axios from 'axios'
  import DateUtil from "../../../util/DateUtil";
  export default {
    data() {
      return {
        date: new DateUtil(),
        showInternational: false,
        loading: false,
        plan: '',
        formItem: {
        },
        SQDZTList:[],
        pageInfo: {
          pageNo: 1,
          pageSize: 10,
        },
        total: 0,
        preOnboardingColumns: [
          // {
          //   type: 'selection',
          //   width: 60,
          //   align: 'center'
          // },
          {
            title: "申请单号",
            key: "applyNo",
            align: "center",
            width: "170",
          },
          {
            title: "状态",
            key: "beInitiateApplication",
            align: "center",
            width: "120",
          },
          {
            title: "提交日期",
            key: "applicantDate",
            align: "center",
            width: "140",
            render: (h, params) => {
              return h(
                "span",
                this.date.dateVal(params.row.applicantDate, "YYYY/MM/DD")
              );
            }
          },
          {
            title: "应聘职位",
            key: "candidatePosition",
            align: "center",
            width: "180",
          },
          {
            title: "中文姓名",
            key: "userName",
            align: "center",
            width: "120",
          },
          {
            title: "性别",
            key: 'gender',
            width: 120,
            align: 'center',
          },
          {
            title: "年龄",
            key: 'age',
            width: 120,
            align: 'center',
          },
          {
            title: "身份证号码",
            key: 'nationalIdNumber',
            width: 200,
            align: 'center',
          },
          {
            title: "个人邮件地址",
            width: 240,
            key: 'mail',
            align: 'center',
          },
          {
            title: "手机",
            width: 150,
            key: 'mobilePersonal',
            align: 'center',
          },
          {
            title: "查看",
            slot: 'action',
            width: 120,
            fixed: 'right',
            align: 'center',
          },
          {
            title: "发起入职",
            slot: 'action1',
            width: 120,
            fixed: 'right',
            align: 'center',
          },
        ],
        preOnboardingData: [],
        showFormItem: {},
        beUsed: null,
        loading:false,
      };
    },
    created() {
      this.initgetData()
    },
    methods: {
      pageChange(val) {
        this.pageInfo.pageNo = val
        this.initgetData()
      },
      initgetData() {
        let obj = {
          candidatePosition: this.formItem.candidatePosition,
          beInitiateApplication: this.formItem.beInitiateApplication,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
        };
        this.loading = true
        axios.post("OnboardingApplication/SelectIndividualOnboardingApplication", obj).then((res) => {
          this.loading =false
          if (res) {
            this.preOnboardingData = res.data;
            this.SQDZTList=res.optionData.unOnboardingstatus
            this.total = Number(res.pageInfo.total);
          }
        })
      },
      initiateInduction(row, index){
        this.$router.push(
          "/EA05DA2E97A25C31C712A46B53045412BA610C6A6F738319/A3FFBEBFDB713E27?id=" +
          row.id +
          "&isPreList=true"
        );
      },
      preOnboardinglOpen(row, index) {
        this.$router.push(
          "/4241FD062D2FE74465192FFFA0AC4B93/A3FFBEBFDB713E27?id=" +
          row.id +
          "&isPreList=true"
        );
      },
    },
  };
</script>

<style scoped>
  .formRow {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .formCol {
    width: calc((100% - 210px) / 3);
    float: left;
    /* margin-right: 30px; */
  }

  @media screen and (max-width: 640px) {
    .formCol {
      width: 100%;
      margin-right: 0px;
    }

    .photoava {
      margin-top: 0px;
    }
  }

  .bottomBtn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }

  .ivu-date-picker {
    width: 100%
  }
</style>


// WEBPACK FOOTER //
// src/components/process/MyManagement/PreEmployment.vue